/**
 * Publishing a cycle report — may the signed-in person? (build contract §2.8)
 *
 * Mirrors the check `publish_cycle_report` makes (migration 1008): the cycle
 * owner, a workspace admin or owner, a super admin, or anyone holding
 * `process.publish`. Admins hold every permission action on the client, so
 * `can('process.publish')` covers the admin and super-admin arms. The screen
 * asks the same question so Publish is drawn only for someone the act will
 * accept, and shows a plain line to everyone else; the function stays the
 * authority.
 */
import type { PermissionAction } from '../types/prioritization/permissions';

export interface CycleReportPublishRightInput {
  userId: string | null | undefined;
  /** `degap_cycles.owner_id` of the report's cycle, when the cycle is loaded. */
  cycleOwnerId: string | null | undefined;
  can: (action: PermissionAction) => boolean;
}

export function cycleReportPublishAllowed({ userId, cycleOwnerId, can }: CycleReportPublishRightInput): boolean {
  if (!userId) return false;
  if (cycleOwnerId && cycleOwnerId === userId) return true;
  return can('process.publish');
}

/** The plain line drawn in place of Publish: what the act takes and who holds it. */
export function cycleReportPublishLine(ownerName: string | null | undefined): string {
  const owner = ownerName ? `the cycle owner (${ownerName})` : 'the cycle owner';
  return `Publishing these priorities takes ${owner}, a workspace admin, or someone with the Publish Cycle Results permission.`;
}
